import { addContainer, addCard, addElement, removeNode, duplicateNode, moveNode, addCardFromTemplate, addContainerFromTemplate } from "../pageNodeEngine";


export function useNodeActions(page, setPage) {
  const addContainerAction = (sectionId) => {
    setPage(prev => addContainer(prev, sectionId));
  };

  const addCardAction = (sectionId, containerId) => {
    setPage(prev => addCard(prev, sectionId, containerId));
  };

  const addElementAction = (sectionId, containerId, cardId, element,index) => {
    setPage(prev => addElement(prev, sectionId, containerId, cardId, element,index));
  };

  const removeNodeAction = (nodeId) => {
    setPage(prev => removeNode(prev, nodeId));
  };

  const duplicateNodeAction = (nodeId) => {
    setPage(prev => duplicateNode(prev, nodeId));
  };

  const moveNodeAction = (nodeId, direction) => {
    setPage(prev => moveNode(prev, nodeId, direction));
  };
  function addCardFromTemplateAction(secId, conId, template, index) {
  setPage(prev => addCardFromTemplate(prev, secId, conId, template, index));
}function addContainerFromTemplateAction(secId, template, index) {
  setPage(prev => addContainerFromTemplate(prev, secId,  template, index));
}


  return {
    addContainerAction,
    addCardAction,
    addElementAction,
    removeNodeAction,
    duplicateNodeAction,
    moveNodeAction,
    addCardFromTemplateAction,
    addContainerFromTemplateAction
  };
}



